import { Control, Controller, FieldValues, Path, PathValue } from "react-hook-form";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { useTranslateMessage } from "@/hooks/useTranslateMessage";

interface ControlledCheckboxProps<T extends FieldValues> {
  name: Path<T>;
  control: Control<T>;
  defaultValue?: PathValue<T, Path<T>>;
  label?: string;
  disabled?: boolean;
  onCheckedChange?: (checked: boolean) => void;
}

export const ControlledCheckbox = <T extends FieldValues>({
  control,
  name,
  defaultValue,
  label,
  disabled,
  onCheckedChange,
}: ControlledCheckboxProps<T>) => {
  const translateMessage = useTranslateMessage();
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field: { value, onChange, ref }, fieldState: { error } }) => (
        <div className="flex flex-row items-center gap-2">
          <Checkbox
            id={name}
            ref={ref}
            checked={!!value}
            onCheckedChange={(checked) => {
              const newValue = !!checked;
              onChange(newValue);
              onCheckedChange?.(newValue);
            }}
            disabled={disabled}
          />
          {label && <Label htmlFor={name}>{label}</Label>}
          {error && <p className="text-sm text-red-500">{translateMessage(error.message)}</p>}
        </div>
      )}
    />
  );
};
